import FileBookmarks from './FileBookmarks';
import './FileBookmarks.scss';

export default FileBookmarks;
